import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "post" };
import { ref, reactive } from "vue";
import imgUpload from "@/components/Upload.vue";
import { ElMessage } from "element-plus";
import { updateHomeInfo } from "@/api/home";
export default /*@__PURE__*/ _defineComponent({
    __name: 'post',
    emits: ["saved"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const dialogVisible = ref(false);
        const title = ref("修改首页信息");
        const form = reactive({
            productTitle: "",
            honorTitle: "",
            introTitle: "",
        });
        const productImgUrl = ref([]);
        const productImgIds = ref([]);
        const honorImgUrl = ref([]);
        const honorImgIds = ref([]);
        const introImgUrl = ref([]);
        const introImgIds = ref([]);
        const wechatImgUrl = ref([]);
        const wechatImgIds = ref([]);
        const douyinImgUrl = ref([]);
        const douyinImgIds = ref([]);
        const xhsImgUrl = ref([]);
        const xhsImgIds = ref([]);
        const imgMap = {
            product: { url: productImgUrl, ids: productImgIds },
            honor: { url: honorImgUrl, ids: honorImgIds },
            intro: { url: introImgUrl, ids: introImgIds },
            wechat: { url: wechatImgUrl, ids: wechatImgIds },
            douyin: { url: douyinImgUrl, ids: douyinImgIds },
            xhs: { url: xhsImgUrl, ids: xhsImgIds },
        };
        const onUpload = (key, val) => {
            imgMap[key].url.value = val.pictureUrls;
            imgMap[key].ids.value = val.pictureIds;
        };
        const buildData = () => ({
            id: "1",
            productTitle: form.productTitle,
            productImages: JSON.stringify(productImgUrl.value),
            honorTitle: form.honorTitle,
            honorImages: JSON.stringify(honorImgUrl.value),
            introTitle: form.introTitle,
            introImages: JSON.stringify(introImgUrl.value),
            wechatQrCode: wechatImgUrl.value[0] || "",
            douyinQrCode: douyinImgUrl.value[0] || "",
            xiaohongshuQrCode: xhsImgUrl.value[0] || "",
        });
        const show = (data) => {
            form.productTitle = data?.productTitle || "";
            form.honorTitle = data?.honorTitle || "";
            form.introTitle = data?.introTitle || "";
            try {
                productImgUrl.value = JSON.parse(data?.productImages || "[]");
            }
            catch {
                productImgUrl.value = [];
            }
            productImgIds.value = [];
            try {
                honorImgUrl.value = JSON.parse(data?.honorImages || "[]");
            }
            catch {
                honorImgUrl.value = [];
            }
            honorImgIds.value = [];
            try {
                introImgUrl.value = JSON.parse(data?.introImages || "[]");
            }
            catch {
                introImgUrl.value = [];
            }
            introImgIds.value = [];
            wechatImgUrl.value = data?.wechatQrCode ? [data.wechatQrCode] : [];
            wechatImgIds.value = [];
            douyinImgUrl.value = data?.douyinQrCode ? [data.douyinQrCode] : [];
            douyinImgIds.value = [];
            xhsImgUrl.value = data?.xiaohongshuQrCode ? [data.xiaohongshuQrCode] : [];
            xhsImgIds.value = [];
            dialogVisible.value = true;
        };
        const handleConfirm = async () => {
            try {
                await updateHomeInfo(buildData());
                ElMessage.success("保存成功");
                dialogVisible.value = false;
                emit("saved");
            }
            catch {
                ElMessage.error("保存失败");
            }
        };
        __expose({ show });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((dialogVisible).value = $event)),
                    title: title.value,
                    "close-on-click-modal": false,
                    center: "",
                    style: { "width": "35%" }
                }, {
                    footer: _withCtx(() => [
                        _createVNode(_component_el_button, {
                            onClick: _cache[9] || (_cache[9] = ($event) => (dialogVisible.value = false))
                        }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode("取消", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: handleConfirm
                        }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode("确认", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            model: form,
                            ref: "formRef",
                            "label-width": "auto",
                            size: "default"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "产品标题：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.productTitle,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.productTitle) = $event)),
                                            placeholder: "请填写产品标题"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "产品展示：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: productImgUrl.value,
                                            imgIds: productImgIds.value,
                                            onUploader: _cache[1] || (_cache[1] = (v) => onUpload('product', v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "荣誉标题：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.honorTitle,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.honorTitle) = $event)),
                                            placeholder: "请填写荣誉标题"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "荣誉展示：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: honorImgUrl.value,
                                            imgIds: honorImgIds.value,
                                            limit: 10,
                                            onUploader: _cache[3] || (_cache[3] = (v) => onUpload('honor', v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "介绍标题：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.introTitle,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.introTitle) = $event)),
                                            placeholder: "请填写介绍标题"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "介绍展示：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: introImgUrl.value,
                                            imgIds: introImgIds.value,
                                            limit: 10,
                                            onUploader: _cache[5] || (_cache[5] = (v) => onUpload('intro', v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "微信二维码：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: wechatImgUrl.value,
                                            imgIds: wechatImgIds.value,
                                            onUploader: _cache[6] || (_cache[6] = (v) => onUpload('wechat', v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "抖音二维码：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: douyinImgUrl.value,
                                            imgIds: douyinImgIds.value,
                                            onUploader: _cache[7] || (_cache[7] = (v) => onUpload('douyin', v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "小红书二维码：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: xhsImgUrl.value,
                                            imgIds: xhsImgIds.value,
                                            onUploader: _cache[8] || (_cache[8] = (v) => onUpload('xhs', v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"])
            ]));
        };
    }
});
